import script from "./InspectRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectRecord.vue?vue&type=script&setup=true&lang=js"

import "./InspectRecord.vue?vue&type=style&index=0&id=502169e1&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-502169e1"]])

export default __exports__